import { render, staticRenderFns } from "./BuyingStationList.vue?vue&type=template&id=15595058&scoped=true"
import script from "./BuyingStationList.vue?vue&type=script&lang=js"
export * from "./BuyingStationList.vue?vue&type=script&lang=js"
import style0 from "./BuyingStationList.vue?vue&type=style&index=0&id=15595058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15595058",
  null
  
)

export default component.exports